<template>
  <modal
    v-if="showSettingModal"
    :scrollY="true"
    @dismissed="closeModal"
    @leave="closeModal"
    :showCloseBtn="true"
    :modalClass="'bg-white rounded-lg shadow-lg p-6 relative my-6 max-w-lg min-w-1/2'"
  >
    <div class="flex h-full w-full flex-col items-center">
      <div class="bg-white mt-5 rounded p-3  w-full">
        <div class="w-full flex flex-col md:flex-row justify-between border-b">
          <div class="flex-1 flex flex-col items-center md:flex-row align-middle">
            <button @click="tab = 'settings'" class="p-3 text-grey text-lg font-bold md:mr-3 pr-16 border-right flex items-center">
              <div class="w-8 h-8 text-white float-left" :class=" tab === 'settings' ? 'bg-tertiary' : 'bg-grey-light'">
                <icon name="qrcode-icon" class="text-white" />
              </div>
              <span class="border-b-2 border-white p-2 uppercase" :class="{'text-grey-darkest': tab === 'settings'}">Qr Code Settings</span>
            </button>

            <button @click="tab = 'appearance'" class="p-3 text-grey text-lg font-bold pl-4 md:mr-3 flex items-center">
              <div class="w-8 h-8 text-white float-left" :class=" tab === 'appearance' ? 'bg-tertiary' : 'bg-grey-light'">
                <icon name="qrcode-icon" class="text-white" />
              </div>
              <span class="border-b-2 border-white p-2" :class="{'text-grey-darkest': tab === 'appearance'}">Qr Code Appearance</span>
            </button>

          </div>
        </div>

        <settings v-if="tab === 'settings'"></settings>
        <appearance v-if="tab === 'appearance'"></appearance>
      </div>
    </div>
  </modal>
</template>

<script>
import Settings from './Settings'
import Appearance from './Appearance'

export default {
  name: 'qr-code-setting',

  components: {
    Settings,
    Appearance
  },

  props: ['showSettingModal'],

  data () {
    return {
      tab: 'settings'
    }
  },

  created () {
  },

  methods: {
    closeModal: function () {
      this.$emit('close-setting')
    }
  }
}
</script>
